import { Form, Field } from 'react-final-form'
import { connect } from 'react-redux';
import { useState } from 'react'
import { contactUs } from '../../actions'
const ContactForm = ({ authentication, contactUs }) => {
    const [loading, setLoading] = useState(false)
    const [formMessage, setFormMessage] = useState({status: '', message: ""})
    const onSubmit = (formValues) => {
        setLoading(true)
        contactUs(formValues, setFormMessage, setLoading)
        
    }
    const initialValues = authentication.loginStatus ? {first_name: authentication.first_name, last_name: authentication.last_name, email: authentication.email} : {}
    return (
        <Form onSubmit={onSubmit} initialValues={initialValues} render={(formProps) => (
            <form className="ui form contact-form-main" onSubmit={formProps.handleSubmit}>
                {formMessage.status ? <div className={`ui tiny message ${formMessage.status === 'error' ? "red" : "green"}`}>
                    {formMessage.message}
                </div> : ""}
                <div className="two fields">
                    <div className="field">
                        <label>First Name</label>
                        <Field
                            name="first_name"
                            component="input"
                            type="text"
                            placeholder="First Name"
                            />
                    </div>
                    <div className="field">
                        <label>Last Name</label>
                        <Field
                            name="last_name"
                            component="input"
                            type="text"
                            placeholder="Last Name"
                            />
                    </div>
                </div>
                <div className="field">
                    <label>Email</label>
                    <Field
                            name="email"
                            component="input"
                            type="email"
                            placeholder="Email"
                            />
                </div>
                <div className="field">
                    <label>Message</label>
                    <Field
                            name="message"
                            component="textarea"
                            type="text"
                            placeholder="Enter Your Message"
                            />
                </div>
                <div className="action" style={{textAlign: 'right'}}><button className={`ui button secondary ${loading ? "loading" : ""}`} tabIndex="0" type="submit">Send</button></div>
            </form>
        )} />
    )
}
const mapStateToProps = (state) => {
    return {
        authentication: state.Authentication
    }
}
export default connect(mapStateToProps, { contactUs })(ContactForm)